export const cancelRecurringDonation = () => {
  const forms = [
    ...document.querySelectorAll("[data-wm-cancel-recurring-donation]"),
  ];

  if (forms.length === 0) {
    return;
  }

  let form;

  const internalPreloader = (action) => {
    const preloader = form.querySelector("[data-wm-preloader]");
    preloader.hidden = action !== "show";
  };

  const loadForm = () => {
    form = document.querySelector("dialog form");
    form.addEventListener("submit", submitForm);
  };

  const disableForm = () => {
    form.style.pointerEvents = "none";
    form.style.opacity = ".6";
  };

  const submitForm = (event) => {
    event.preventDefault();
    internalPreloader("show");
    disableForm();

    const formId = form.dataset.wmCancelRecurringDonationFormId;

    fetch("https://donate.wemove.eu/payment/recurring/cancel/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        hashedData: form.dataset.wmJson,
      }),
    }).then((response) => {
      internalPreloader("hide");
      wemove.triggerEvent("wm-closeDialog");

      if (response.ok) {
        wemove.triggerEvent("wm-cancelRecurringDonation::cancelled", {
          formId: formId,
        });
        return;
      }

      wemove.triggerEvent("wm-openDialog", {
        querySelector: "data-wm-cancel-recurring-donation-error",
      });
    });
  };

  forms.forEach((form) => {
    const formId = form.dataset.wmCancelRecurringDonation;
    const eventName = `wm-dialogOpened::data-wm-cancel-recurring-donation='${formId}'`;
    document.addEventListener(eventName, loadForm);
  });
};
